import { useEffect } from 'react';

const PreventRefresh = () => {
  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      // Cancel the event
      event.preventDefault();
      // Chrome requires returnValue to be set
      event.returnValue = '';
    };

    const handleKeyDown = (event: any) => {
      // Prevent F5 key (keyCode 116)
      if (event.keyCode === 116) {
        event.preventDefault();
      }
      
      // Prevent Ctrl + R (keyCode 82)
      if (event.ctrlKey && event.keyCode === 82) {
        event.preventDefault();
      }
    };

    // Add event listeners
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('keydown', handleKeyDown);

    // Cleanup function to remove event listeners
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []); // Empty dependency array means this effect runs once on mount

  return null; // This component doesn't render anything
};

export default PreventRefresh;